The value of `PositionOpening.documentId` for the requested object.
